import React from 'react';
import PropTypes from 'prop-types';
import URL from 'url-parse';

import Copy from './Copy';
import {sendShareRequest} from '~/src/utilities/feed/activity.js';
import initPolyglot from '~/src/utilities/libs/polyglot';
import {BeagleEvents, GtmEvents, InteractionSources} from '~/src/utilities/constants/tracking';
import {withTypeContext} from '~/src/components/context/TypeContext';
import ShareLink from '~/src/components/svg/action/ShareLink';
import {TeaserTypes, ContentType} from '~/src/utilities/constants/types';
import {Asset} from '~/src/utilities/constants/asset';
import {trackGtm} from '~/src/utilities/tracking/gtm';

import css from './CopyShare.module.scss';
import i18nStrings from './CopyShare.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class CopyShare extends React.Component {
    state = {
        showCopy: false
    };

    handleClick = () => {
        this.setState({showCopy: !this.state.showCopy});
    };

    onCopyClick = () => {
        const beagleEvent =
            this.props.context.type === TeaserTypes.VIDEOS || this.props.context.type === ContentType.VIDEO
                ? BeagleEvents.VIDEO_COPY_LINK
                : BeagleEvents.STORY_COPY_LINK;
        sendShareRequest(this.props.metadataId, beagleEvent, Asset.STORY);

        trackGtm(GtmEvents.INTERACTION, {
            interactionSource: InteractionSources.SHARE_OVERLAY,
            interactionType: GtmEvents.SHARE_LINK
        });

        window.setTimeout(() => this.setState({showCopy: false}), 2000);
    };

    render() {
        const url = new URL(this.props.url);
        return (
            <div className={css.copyShare}>
                <div className={css.copyShareButton} onClick={this.handleClick} data-testid="CopyShare">
                    <span className={css.shareLogo}>
                        <ShareLink title={getTranslation('copy')} />
                    </span>
                    <span className={css.shareLogo}>{getTranslation('copy')}</span>
                </div>

                {this.state.showCopy && <Copy content={url.href} onCopy={this.onCopyClick} className={css.copyArea} />}
            </div>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    CopyShare.propTypes = {
        metadataId: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    };
}

export {CopyShare};
export default withTypeContext(CopyShare);
